/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosBlockDetailInfo } from '../models/AptosBlockDetailInfo';
import type { AptosBlockDetailRequest } from '../models/AptosBlockDetailRequest';
import type { AptosBlockListInfo } from '../models/AptosBlockListInfo';
import type { AptosBlockListRequest } from '../models/AptosBlockListRequest';
import type { AptosBlockSummaryInfo } from '../models/AptosBlockSummaryInfo';
import type { AptosBlockSummaryRequest } from '../models/AptosBlockSummaryRequest';
import type { AptosBlockTrxListRequest } from '../models/AptosBlockTrxListRequest';
import type { AptosTrxListInfo } from '../models/AptosTrxListInfo';
import type { BabylonBlockDetailIntegratedInfo } from '../models/BabylonBlockDetailIntegratedInfo';
import type { BabylonBlockDetailRequest } from '../models/BabylonBlockDetailRequest';
import type { BabylonBlockEventListInfo } from '../models/BabylonBlockEventListInfo';
import type { BabylonBlockEventListRequest } from '../models/BabylonBlockEventListRequest';
import type { BabylonBlockListInfo } from '../models/BabylonBlockListInfo';
import type { BabylonBlockRequest } from '../models/BabylonBlockRequest';
import type { BabylonBlockSignatureListInfo } from '../models/BabylonBlockSignatureListInfo';
import type { BabylonBlockSignatureListRequest } from '../models/BabylonBlockSignatureListRequest';
import type { BabylonBlockSummaryInfo } from '../models/BabylonBlockSummaryInfo';
import type { BabylonBlockSummaryRequest } from '../models/BabylonBlockSummaryRequest';
import type { BabylonBlockTrxListRequest } from '../models/BabylonBlockTrxListRequest';
import type { BabylonTrxListInfo } from '../models/BabylonTrxListInfo';
import type { EvmBlockDetailInfo } from '../models/EvmBlockDetailInfo';
import type { EvmBlockDetailRequest } from '../models/EvmBlockDetailRequest';
import type { EvmBlockListInfo } from '../models/EvmBlockListInfo';
import type { EvmBlockRequest } from '../models/EvmBlockRequest';
import type { EvmBlockSummaryInfo } from '../models/EvmBlockSummaryInfo';
import type { EvmBlockSummaryRequest } from '../models/EvmBlockSummaryRequest';
import type { EvmInternalTrxGroupInfo } from '../models/EvmInternalTrxGroupInfo';
import type { EvmTrxListInfo } from '../models/EvmTrxListInfo';
import type { HumanityBlockDetailInfo } from '../models/HumanityBlockDetailInfo';
import type { HumanityBlockDetailRequest } from '../models/HumanityBlockDetailRequest';
import type { HumanityBlockInternalTrxListInfo } from '../models/HumanityBlockInternalTrxListInfo';
import type { HumanityBlockInternalTrxListRequest } from '../models/HumanityBlockInternalTrxListRequest';
import type { HumanityBlockListInfo } from '../models/HumanityBlockListInfo';
import type { HumanityBlockRequest } from '../models/HumanityBlockRequest';
import type { HumanityBlockSummaryInfo } from '../models/HumanityBlockSummaryInfo';
import type { HumanityBlockSummaryRequest } from '../models/HumanityBlockSummaryRequest';
import type { HumanityBlockTrxListRequest } from '../models/HumanityBlockTrxListRequest';
import type { HumanityTrxListInfo } from '../models/HumanityTrxListInfo';
import type { KiteBlockDetailInfo } from '../models/KiteBlockDetailInfo';
import type { KiteBlockDetailRequest } from '../models/KiteBlockDetailRequest';
import type { KiteBlockInternalTrxListInfo } from '../models/KiteBlockInternalTrxListInfo';
import type { KiteBlockInternalTrxListRequest } from '../models/KiteBlockInternalTrxListRequest';
import type { KiteBlockListInfo } from '../models/KiteBlockListInfo';
import type { KiteBlockRequest } from '../models/KiteBlockRequest';
import type { KiteBlockSummaryInfo } from '../models/KiteBlockSummaryInfo';
import type { KiteBlockSummaryRequest } from '../models/KiteBlockSummaryRequest';
import type { KiteBlockTrxListRequest } from '../models/KiteBlockTrxListRequest';
import type { KiteTrxListInfo } from '../models/KiteTrxListInfo';
import type { NexonBlockInternalTrxListRequest } from '../models/NexonBlockInternalTrxListRequest';
import type { NexonBlockTrxListRequest } from '../models/NexonBlockTrxListRequest';
import type { SomniaBlockDetailInfo } from '../models/SomniaBlockDetailInfo';
import type { SomniaBlockDetailRequest } from '../models/SomniaBlockDetailRequest';
import type { SomniaBlockInternalTrxListInfo } from '../models/SomniaBlockInternalTrxListInfo';
import type { SomniaBlockInternalTrxListRequest } from '../models/SomniaBlockInternalTrxListRequest';
import type { SomniaBlockListInfo } from '../models/SomniaBlockListInfo';
import type { SomniaBlockRequest } from '../models/SomniaBlockRequest';
import type { SomniaBlockSummaryInfo } from '../models/SomniaBlockSummaryInfo';
import type { SomniaBlockSummaryRequest } from '../models/SomniaBlockSummaryRequest';
import type { SomniaBlockTrxListRequest } from '../models/SomniaBlockTrxListRequest';
import type { SomniaTrxListInfo } from '../models/SomniaTrxListInfo';
import type { ZerogBlockDetailInfo } from '../models/ZerogBlockDetailInfo';
import type { ZerogBlockDetailRequest } from '../models/ZerogBlockDetailRequest';
import type { ZerogBlockInternalTrxListInfo } from '../models/ZerogBlockInternalTrxListInfo';
import type { ZerogBlockInternalTrxListRequest } from '../models/ZerogBlockInternalTrxListRequest';
import type { ZerogBlockListInfo } from '../models/ZerogBlockListInfo';
import type { ZerogBlockRequest } from '../models/ZerogBlockRequest';
import type { ZerogBlockSummaryInfo } from '../models/ZerogBlockSummaryInfo';
import type { ZerogBlockSummaryRequest } from '../models/ZerogBlockSummaryRequest';
import type { ZerogBlockTrxListRequest } from '../models/ZerogBlockTrxListRequest';
import type { ZerogTrxListInfo } from '../models/ZerogTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BlockControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBlockDetail({
        requestBody,
    }: {
        requestBody: (AptosBlockDetailRequest | EvmBlockDetailRequest | HumanityBlockDetailRequest | KiteBlockDetailRequest | BabylonBlockDetailRequest | SomniaBlockDetailRequest | ZerogBlockDetailRequest),
    }): CancelablePromise<(AptosBlockDetailInfo | EvmBlockDetailInfo | HumanityBlockDetailInfo | KiteBlockDetailInfo | BabylonBlockDetailIntegratedInfo | SomniaBlockDetailInfo | ZerogBlockDetailInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/block',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTransactionList({
        requestBody,
    }: {
        requestBody: (HumanityBlockTrxListRequest | KiteBlockTrxListRequest | NexonBlockTrxListRequest | AptosBlockTrxListRequest | BabylonBlockTrxListRequest | SomniaBlockTrxListRequest | ZerogBlockTrxListRequest),
    }): CancelablePromise<(HumanityTrxListInfo | KiteTrxListInfo | EvmTrxListInfo | AptosTrxListInfo | BabylonTrxListInfo | SomniaTrxListInfo | ZerogTrxListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/block/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getInternalTrxListByBlockNumber({
        requestBody,
    }: {
        requestBody: (NexonBlockInternalTrxListRequest | HumanityBlockInternalTrxListRequest | KiteBlockInternalTrxListRequest | SomniaBlockInternalTrxListRequest | ZerogBlockInternalTrxListRequest),
    }): CancelablePromise<(EvmInternalTrxGroupInfo | HumanityBlockInternalTrxListInfo | KiteBlockInternalTrxListInfo | SomniaBlockInternalTrxListInfo | ZerogBlockInternalTrxListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/block/transaction/internal/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBlockSummaryList({
        requestBody,
    }: {
        requestBody: (AptosBlockSummaryRequest | EvmBlockSummaryRequest | HumanityBlockSummaryRequest | KiteBlockSummaryRequest | SomniaBlockSummaryRequest | BabylonBlockSummaryRequest | ZerogBlockSummaryRequest),
    }): CancelablePromise<Array<(AptosBlockSummaryInfo | EvmBlockSummaryInfo | HumanityBlockSummaryInfo | KiteBlockSummaryInfo | SomniaBlockSummaryInfo | BabylonBlockSummaryInfo | ZerogBlockSummaryInfo)>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/block/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBlockDetailSignatures({
        requestBody,
    }: {
        requestBody: BabylonBlockSignatureListRequest,
    }): CancelablePromise<BabylonBlockSignatureListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/block/signatures',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBlockList({
        requestBody,
    }: {
        requestBody: (AptosBlockListRequest | EvmBlockRequest | HumanityBlockRequest | KiteBlockRequest | BabylonBlockRequest | SomniaBlockRequest | ZerogBlockRequest),
    }): CancelablePromise<(AptosBlockListInfo | EvmBlockListInfo | HumanityBlockListInfo | KiteBlockListInfo | BabylonBlockListInfo | SomniaBlockListInfo | ZerogBlockListInfo)> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/block/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBlockDetailFinalizeBlockEvents({
        requestBody,
    }: {
        requestBody: BabylonBlockEventListRequest,
    }): CancelablePromise<BabylonBlockEventListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/block/finalize/block/events',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
